import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfAccordion.module.scss';
import AcfAccordionItem from './AcfAccordionItem/AcfAccordionItem';
import { PlusIcon, MinusIcon, CircledChevronDown, CircledChevronUp, Accordion } from '@/components';

let cx = classNames.bind(styles);

export default function AcfAccordion(props) {
	const { accordion, attributes, clientId } = props;
	const className = attributes.className?.split(' ') || [];
	let openIcon, closeIcon;

	if (accordion.upDownIcons) {
		if (accordion.upDownIcons === 'plus-minus') {
			openIcon = <PlusIcon className={cx('accordion-plus-minus')} />;
			closeIcon = <MinusIcon className={cx('accordion-plus-minus')} />;
		} else if (accordion.upDownIcons === 'chevrons') {
			openIcon = <CircledChevronDown className={cx('accordion-chevron')} />;
			closeIcon = <CircledChevronUp className={cx('accordion-chevron')} />;
		}
	} else {
		throw Error('Accordion icons not set.');
	}

	return (
		<>
			{accordion?.items && accordion.items.length > 0 && (
				<Accordion id={attributes.anchor || clientId} className={cx([`accordion-icon-${accordion.upDownIcons}`, ...className, accordion.cards && 'style-cards'])} openIcon={openIcon} closeIcon={closeIcon} anchorsEnabled={accordion.enableAnchorLinks} expandMultipleItems={accordion.expandMultipleItems}>
					{accordion.items.map((item, index) => (
						<AcfAccordionItem key={`${clientId}-${index}`} anchor={item.anchor} isCard={accordion.cards} item={item} elem={accordion.headingLevel} />
					))}
				</Accordion>
			)}
		</>
	);
}

AcfAccordion.fragments = {
	key: `AcfAccordionFragment`,
	entry: gql`
		fragment AcfAccordionFragment on AcfAccordion {
			accordion {
				cards
				enableAnchorLinks
				expandMultipleItems
				headingLevel
				items {
					anchor
					body
					header
				}
				upDownIcons
			}
			attributes {
				anchor
				className
			}
			clientId
		}
	`,
};

AcfAccordion.config = {
	name: 'AcfAccordion',
};
AcfAccordion.displayName = 'AcfAccordion';
